import { render } from "./CreateAutoScaleVmGroup.vue?vue&type=template&id=cfb0c0d2&scoped=true"
import script from "./CreateAutoScaleVmGroup.vue?vue&type=script&lang=js"
export * from "./CreateAutoScaleVmGroup.vue?vue&type=script&lang=js"

import "./CreateAutoScaleVmGroup.vue?vue&type=style&index=0&id=cfb0c0d2&lang=less&scoped=true"
import "./CreateAutoScaleVmGroup.vue?vue&type=style&index=1&id=cfb0c0d2&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb0c0d2"]])

export default __exports__